import { render, staticRenderFns } from "./elPhone.vue?vue&type=template&id=32d819ec&scoped=true"
import script from "./elPhone.vue?vue&type=script&lang=js"
export * from "./elPhone.vue?vue&type=script&lang=js"
import style0 from "./elPhone.vue?vue&type=style&index=0&id=32d819ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d819ec",
  null
  
)

export default component.exports